import { set } from 'lodash-es';

/* eslint-disable @typescript-eslint/no-explicit-any */

export const cleanCmsTranslations = function (translations: any) {
    const removeEmpty = (obj: Record<string, string>) => {
        return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
    };

    let result: Record<string, string> = {};
    Object.keys(translations).forEach((trad) => {
        const key = cleanCmsScopeKey(trad);
        result[key] = translations[trad];
    });
    result = removeEmpty(result);
    result = copyDeeplyObject(result);
    return result;
};

export const cleanCmsScopeKey = (key: string) => {
    const keyCleaned = key.replace(/^(Uxeng)/, '');
    return keyCleaned.charAt(0).toLowerCase() + keyCleaned.slice(1);
};

export function copyDeeplyObject(obj: any) {
    const result: any = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object') {
                result[key] = copyDeeplyObject(obj[key]);
            } else {
                set(result, key, obj[key]);
            }
        }
    }

    return result;
}
